import React from "react";
import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../common/Table/table";
import { Modal } from "react-bootstrap";
import AddUpdateRetailer from "./addUpdateRetailer";
import {
  getRetailerSlice,
  getRetailerByIdSlice,
  addRetailerSlice,
  updateRetailerSlice,
  deleteRetailerSlice,
  resetAddRetailerMessage,
  resetUpdateRetailerMessage,
  resetDeleteRetailerMessage,
} from "../../../store/slices/retailerSlice";
import { getGstinTypeSlice } from "../../../store/slices/gstinTypeSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import ViewModal from "../../common/viewModal/globalViewModal";

const Retailer = () => {
  const dispatch = useDispatch();
  const [showModal, setModalVisible] = useState(false);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [deleteRetailer, setDeleteRetailer] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [pageLimit, setPageLimit] = useState(10);

  const tableHead = [
    { title: "Retailer Name", key: "name" },
    { title: "Mobile No.", key: "contact" },
    { title: "GSTIN", key: "gstin" },
    { title: "Status", key: "status" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    gstin: "",
    address: "",
    status: "Active ",
    gstinType: "",
    gstinTypeName: "",
    dlno: "",
    email: "",
  });
  const [inputError, setInputError] = useState({
    name: false,
  });

  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const {
    retailer,
    retailerById,
    addRetailerSuccessMessage,
    addRetailerErrorMessage,
    updateRetailerSuccessMessage,
    updateRetailerErrorMessage,
    deleteRetailerSuccessMessage,
    deleteRetailerErrorMessage,
    searchRetailerErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.retailer);
  const { gstinTypes } = useSelector((state) => state.gstinType);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const { tableStatus } = useSelector((state) => state.tableStatusChange);
  useEffect(() => {
    showTostifyMessageAndReset(
      addRetailerSuccessMessage,
      showToastifySuccess,
      resetAddRetailerMessage
    );
    showTostifyMessageAndReset(
      addRetailerErrorMessage,
      showToastifyError,
      resetAddRetailerMessage
    );
    showTostifyMessageAndReset(
      updateRetailerSuccessMessage,
      showToastifySuccess,
      resetUpdateRetailerMessage
    );
    showTostifyMessageAndReset(
      updateRetailerErrorMessage,
      showToastifyError,
      resetUpdateRetailerMessage
    );
    showTostifyMessageAndReset(
      deleteRetailerSuccessMessage,
      showToastifySuccess,
      resetDeleteRetailerMessage
    );
    showTostifyMessageAndReset(
      deleteRetailerErrorMessage,
      showToastifyError,
      resetDeleteRetailerMessage
    );
  }, [
    addRetailerSuccessMessage,
    addRetailerErrorMessage,
    updateRetailerSuccessMessage,
    updateRetailerErrorMessage,
    deleteRetailerSuccessMessage,
    deleteRetailerErrorMessage,
    showTostifyMessageAndReset,
  ]);

  const clinicId =  clinicInfo?.[0]?.clinicId ||null;

  useEffect(() => {
    dispatch(getGstinTypeSlice({ status: ["Active"], token }));
  }, [dispatch, token, showModal]);

  const fetchRetailer = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
  if (clinicId && token) {
  dispatch(
    getRetailerSlice({
            clinicId,
            status: tableStatus,
            token,
            currentPage: page,
            limit: lim,
            name: search || undefined,
          })
        );
      }
    },
    [clinicId, token, dispatch, tableStatus, searchValue, pageLimit]
  );
  useEffect(() => {
    fetchRetailer();
  }, [fetchRetailer, showModal, showDeleteModal, showGlobalViewModal]);

  const handlePageChange = (page) => {
    fetchRetailer(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchRetailer(1, newLimit, searchValue);
  };

  const handleChange = (e, field = null) => {
    if (field === "gstinType") {
      setFormData((prev) => ({
        ...prev,
        gstinType: e?.value || "",
        gstinTypeName: e?.label || "",
      }));
    } else if (e?.target) {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (e?.editor) {
      const value = e.editor.getData();
      setFormData((prev) => ({
        ...prev,
        address: value,
      }));
    }
  };

  const stripHtmlTags = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>/g, "");
  };
  const handleModal = (action, retailer = null) => {
    if (action === "create") {
      setFormData({
        name: "",
        contact: "",
        gstin: "",
        address: "",
        status: "Active",
        gstinType: "",
        gstinTypeName: "",
        dlno: "",
        email: "",
      });
    } else if (action === "edit" && retailer) {
      setFormData({
        id: retailer?.id,
        name: retailer?.name,
        email: retailer?.email,
        contact: retailer?.contact,
        gstin: retailer?.gstin,
        address: stripHtmlTags(retailer?.address),
        gstinType: retailer?.gstinType?._id,
        gstinTypeName: retailer?.gstinType?.name,
        dlno: retailer?.dlno,
        status: retailer?.status,
      });
    }
    setModalVisible(true);
    setModalAction(action);
  };

  const handleEdit = async (retailer) => {
    try {
      const response = await dispatch(
        getRetailerByIdSlice({ id: retailer?.id, token })
      );
      if (response?.payload) {
        const retailerData = response?.payload?.result?.list;
        handleModal("edit", retailerData);
        setFormData({
          id: retailerData?._id,
          name: retailerData?.name,
          email: retailerData?.email,
          contact: retailerData?.contact,
          gstin: retailerData?.gstin,
          address: stripHtmlTags(retailerData?.address),
          gstinType: retailerData?.gstinType?._id,
          gstinTypeName: retailerData?.gstinType?.name,
          dlno: retailerData?.dlno,
          status: retailerData?.status,
        });
      }
    } catch (error) {
      console.error("Failed to get Retailer. Please Try Later..", error);
    }
  };
  const handleAddOrUpdateRetailer = async (e) => {
    e.preventDefault();
    try {
      const { name } = inputError;
      if (name) {
        return;
      }
      if (modalAction === "create") {
        await dispatch(
          addRetailerSlice({
            ...formData,
           clinicId,
            token,
          })
        );
      } else {
        await dispatch(
          updateRetailerSlice({
            ...formData,
           clinicId,
            token,
          })
        );

        fetchRetailer();
      }

      setModalVisible(false);
      setFormData({
        id: "",
        name: "",
        contact: "",
        gstin: "",
        address: "",
        status: "Active",
        gstinType: "",
        gstinTypeName: "",
        dlno: "",
        email: "",
      });
    } catch (error) {
      console.error("Error occurred while handling Retailer operation:", error);
    }
  };

  const handleUpdateStatus = async (status, item) => {
    try {
      const response = await dispatch(
        getRetailerByIdSlice({ id: item?.id, token })
      );
      const retailerData = response?.payload?.result?.list;
      const updateData = {
        id: retailerData?._id,
        name: retailerData?.name,
        email: retailerData?.email,
        contact: retailerData?.contact,
        gstin: retailerData?.gstin,
        address: stripHtmlTags(retailerData?.address),
        gstinType: retailerData?.gstinType?._id,
        gstinTypeName: retailerData?.gstinType?.name,
        status: status,
        clinicId,
        token,
      };

      await dispatch(updateRetailerSlice(updateData));
      if (clinicId) {
        fetchRetailer();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchRetailer(1, pageLimit, value);
    },
    [fetchRetailer, pageLimit]
  );


  const handleShowGlobalViewModal = async (data) => {
    await dispatch(
      getRetailerByIdSlice({
        id: data?.id,
       clinicId,
        token,
      })
    );
    setShowGlobalViewModal(true);
  };

  const handleDeleteRetailer = async () => {
    try {
      await dispatch(
        deleteRetailerSlice({
          id: deleteRetailer,
          clinicId,
          token,
        })
      );
      setDeleteModalVisible(false);
      fetchRetailer();
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const handleDelete = (Id) => {
    setDeleteRetailer(Id.id);
    setDeleteModalVisible(true);
  };
  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          retailer &&
          retailer.map((item) => ({
            id: item?._id,
            name: item?.name || "N/A",
            contact: item?.contact || "N/A",
            gstin: item?.gstin || "N/A",
            status: item?.status || "N/A",
          }))
        }
        handleAddBtn={true}
        handleSearchOption={true}
        searchValue={searchValue}
        handleSearch={handleSearch}
        handleDelete={handleDelete}
        handleDeleteRetailer={handleDeleteRetailer}
        errorMessage={searchRetailerErrorMessage}
        handleEdit={handleEdit}
        addModal={() => handleModal("create")}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleUpdateStatus={handleUpdateStatus}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />
      <AddUpdateRetailer
        handleChange={handleChange}
        setModalVisible={setModalVisible}
        showModal={showModal}
        modalAction={modalAction}
        handleAddOrUpdateRetailer={handleAddOrUpdateRetailer}
        formData={formData}
        handleEdit={handleEdit}
        gstinTypes={gstinTypes}
        setInputError={setInputError}
        inputError={inputError}
      />
      <Modal
        centered
        show={showDeleteModal}
        onHide={() => setDeleteModalVisible(false)}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">Delete AccountType</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to delete this Bank?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModalVisible(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDeleteRetailer}
          >
            Delete
          </button>
        </div>
      </Modal>
      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"lg"}
        titel={tableHead}
        content={{
          id: retailerById?._id,
          name: retailerById?.name,
          contact: retailerById?.contact,
          gstin: retailerById?.gstin,
          accountType: retailerById?.accountType?.name,
          status: retailerById?.status,
        }}
      />
    </div>
  );
};

export default Retailer;
